import { render, staticRenderFns } from "./icon-close.vue?vue&type=template&id=030ce586&"
import script from "./icon-close.vue?vue&type=script&lang=js&"
export * from "./icon-close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports